module.exports = __webpack_public_path__ + "images/blog/table/scroll_4359b6464cf6019b06645eaf2c548dc5.svg";